<template>
  <div class="changeChargeCard">
    <Loading v-show="loading"></Loading>
    <h1>クレジットカードを変更</h1>
    <div class="change-inner">
      <formfield id="ccn">
          <label for="ff1_input">カード番号</label>
          <input id="ff1_input" type="text" maxlength="4" placeholder="1234" name="cno" v-model="cardnum1" autofocus/>
          <input type="text" maxlength="4" placeholder="5678" v-model="cardnum2" name="cno"/>
          <input type="text" maxlength="4" placeholder="9012" v-model="cardnum3" name="cno"/>
          <input type="text" maxlength="4" placeholder="3456" v-model="cardnum4" name="cno"/>
        </formfield>
        <formfield id="ch">
          <label for="ff2_input">名義人名前</label>
          <input id="ff2_input" type="text" v-model="cardname1" placeholder="姓"/>
          <input type="text" v-model="cardname2" placeholder="名"/>
        </formfield>
        <formfield id="ed">
          <label>有効期限</label>
          <select v-model="exp_month" id="month">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
          </select>
          <select v-model="exp_year" id="year">
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
            <option value="2031">2031</option>
            <option value="2032">2032</option>
            <option value="2033">2033</option>
            <option value="2034">2034</option>
            <option value="2035">2035</option>
            <option value="2036">2036</option>
            <option value="2037">2037</option>
            <option value="2038">2038</option>
            <option value="2039">2039</option>
            <option value="2040">2040</option>
          </select>
        </formfield>
        <formfield id="sc">
          <label for="ff4_input">CVC番号</label>
          <input v-model="cvc" id="ff4_input" type="text" maxlength="3" placeholder="CVC"/>
        </formfield>
        <formfield id="sc">
        <label class="title">パスコード</label>
        <input type="password" v-model="passcode" id="password" placeholder="例）123456">
        </formfield>
        <button id="register" type="" v-on:click="registerCard()">クレジットカードを登録する</button>
    </div>
  </div>
</template>
<style scoped>
.change-inner{
  width: 60%;
  margin:0 auto;
  background: white;
  text-align: left;
}
.change-inner .title{
  text-align: left;
  width: 30%;
}
.change-inner input{
  width: 70%;
}
.change-inner table{
  width: 100%;
}
 #register{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
  border:0px;
  width: 100%;
}
formfield {
  float: left;
  width: 100%;
}

label {
  float: left;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6em;
  margin-bottom: 5px;
  color: #92A3A6;
}

input, select, button {
  float: left;
  background: transparent;
  border: 2px solid #EBEBEB;
  border-radius: 3px;
  padding: 5px 10px;
  margin: 0 10px 10px 0;
  font-size: 1.2em;
  line-height: 2em;
  transition: border 300ms ease-in;
}

input:focus, select:focus {
  border-color: #20A8FF;
}

input::-webkit-input-placeholder {
  color: rgba(146,163,166,.5);
}


#ccn input[type="text"] {
  width: calc(25% - 10px);
  letter-spacing: 2px;
  text-align: center;
}

#ch input[type="text"] {
  width: calc(50% - 10px);
  text-align: start;
}

#ed, #sc {
  width: 50%;
}

#sc input[type="text"] {
  width: calc(100% - 10px);
}

#ed select {
  background: #fff;
  height: 46px;
  width: calc(50% - 10px);
  line-height: 2em;
  text-align: center;
  font-size: 14px;
}

#cc {
  width: 50%;
}
.footer-contents{
  display: none!important;
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'ChangeMail',
  components: {
  },
  data () {
    return {
      db: null,
      loading: false,
      mail: null,
      userId: null,
      passcode: null,
      cardnum1: null,
      cardnum2: null,
      cardnum3: null,
      cardnum4: null,
      cardname1: null,
      cardname2: null,
      exp_month: null,
      exp_year: null,
      customerId: null,
      cvc: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/,
      numberPattern: /^([1-9]\d*|0)$/,
      halfNumsizePattern: /^[0-9]*$/
    }
  },
  methods: {
    registerCard: function () {
      // クレジットカード情報
      if (!this.cardnum1 || !this.cardnum2 || !this.cardnum3 || !this.cardnum4) {
        alert('カード番号を入力してください。')
        return
      }
      if (!this.halfNumsizePattern.test(this.cardnum1) || !this.halfNumsizePattern.test(this.cardnum2) || !this.halfNumsizePattern.test(this.cardnum3) || !this.halfNumsizePattern.test(this.cardnum4)) {
        alert('カード番号は半角数字で入力してください。')
        return
      }
      this.number = this.cardnum1 + this.cardnum2 + this.cardnum3 + this.cardnum4

      if (!this.cardname1 || !this.cardname2) {
        alert('カードの名義人の名前を入力してください。')
        return
      }
      this.cardname = this.cardname1 + this.cardname2

      if (!this.exp_month) {
        alert('カードの有効期限月を入力してください。')
        return
      }
      if (!this.exp_year) {
        alert('カードの有効期限年を入力してください。')
        return
      }
      if (!this.cvc) {
        alert('CVC番号を入力してください。')
        return
      }
      if (!this.halfNumsizePattern.test(this.cvc) ) {
        alert('CVC番号は半角数字で入力してください。')
        return
      }
      if (!this.passcode) {
        alert('認証に必要なパスコードを入力してください。')
        return
      }
      if (!this.numberPattern.test(this.passcode)) {
        alert('パスコードの入力が正しくありません。')
        return
      }


      let self = this
      self.loading = true
      var exist = false
      this.db.collection('confirmations').where('mail', '==', this.mail).where('passcode', '==', parseInt(this.passcode, 10)).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          //期限が切れてないかチェック
          self.userId = doc.get('userId')
          var limitdate = doc.get('limitedDate').toDate()
          let now = new Date()
          if (limitdate.getTime() < now.getTime()) {
            exist = false
            alert('パスコードの期限が過ぎております、再度メールアドレスの変更手続きから行ってください。')
            self.loading = false
          } else {
            exist = true
            //　成功。PayJpのユーザー情報にあるカード情報を変更する
            self.changeCard()
            
          }
        })
        if (!exist) {
          alert('パスコードが正しくありません、再度確認してから新しいメールアドレスの変更手続きをしましょう。')
          self.loading = false
          return
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('新しいメールアドレスの変更に失敗しました。エラーです。')
          self.loading = false
          return
        })
    },
    changeCard: function () {
      let self = this
      console.log(this.customerId)
      console.log(this.number)
      console.log(this.cvc)
      console.log(this.exp_year)
      console.log(this.exp_month)
      var data = {'id': this.customerId, 'number': this.number , 'cvc': this.cvc, 'exp_year': this.exp_year, 'exp_month': this.exp_month, 'name': this.cardname}
              $.ajax({
                url: 'https://weart-marketing.com/api/7200kcal/updateCard/',
                type: 'POST',
                data: data
              })
              .done(function (data) {
                console.log('dwehduiewdhwqedwq')
                console.log(data)
                console.log('dwehduiewdhwqedwq')
              
                self.loading = false
                alert('クレジットカードの変更が完了しました！マイページへ戻ります。')
                location.href = '/mypage?userId=' + self.userId
              })
              .fail(function (error) {
                self.loading = false
                alert('クレジットカードの変更に失敗しました、カード情報が正しいか再度チェックしてから、クレジットカードの変更の手続きをお願い致します。')
              })
    },
    isUser: function () {
      let self = this
      var exist = false
      this.db.collection('users').where('mail', '==', this.mail).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          exist = true
          self.userId = doc.id
          self.customerId = doc.get('customer')
        })
        if (!exist) {
          //新しいメールアドレスを更新
          alert('メールアドレスが存在しません。不正アクセスの可能性があります。アプリ管理者に報告しました。')
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('送信に失敗しました。エラーです。')
          self.loading = false
          return
        })
    }
  },
  created: function () {
    // Planを取得
    let self = this
    this.db = firebase.firestore()
    firebase.auth().languageCode = 'jp'
    var url = location.search.substring(1)
    var parameters = url.split('&')
    var result = Object()
    for (var i = 0; i < parameters.length; i++) {
      var element = parameters[i].split('=')
      var paramName = decodeURIComponent(element[0])
      var paramValue = decodeURIComponent(element[1])
      result[paramName] = decodeURIComponent(paramValue)
    }
    this.mail = result['mail']
    if (!this.mail) {
      alert('不正アクセスの可能性があります。')
      location.href='/'
    } else {
      this.isUser()
    }
  }
}
</script>
<style type="text/css">

  
</style>



// WEBPACK FOOTER //
// src/components/changeChargeCard/ChangeChargeCard.vue